import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '@config/support/helpers/Lang';
import EstateTypeLang from '@/modules/estate/services/EstateTypeLang';

export class PredefinedNomination extends Enum {
  id!: number;
  name!: string;
  type!: string | null;
  clearVaultAccess!: boolean;
  clearEstateAccess!: boolean;

  static EXECUTOR: PredefinedNomination = {
    id: 1,
    get name() {
      return Lang.t('nomination.executor');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static PROFESSIONAL_EXECUTOR: PredefinedNomination = {
    id: 2,
    get name() {
      return Lang.t('nomination.professional-executor');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static SUBSTITUTE_EXECUTOR: PredefinedNomination = {
    id: 3,
    get name() {
      return Lang.t('nomination.substitute-executor');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static SPECIFIC_BENEFICIARY: PredefinedNomination = {
    id: 4,
    get name() {
      return Lang.t('nomination.specific-beneficiary');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static RESIDUAL_BENEFICIARY: PredefinedNomination = {
    id: 5,
    get name() {
      return Lang.t('nomination.residual-beneficiary');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static UNSERVED_BENEFICIARY: PredefinedNomination = {
    id: 6,
    get name() {
      return Lang.t('nomination.unserved-beneficiary');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static ALTERNATE_BENEFICIARY: PredefinedNomination = {
    id: 7,
    get name() {
      return Lang.t('nomination.alternate-beneficiary');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static GUARDIAN: PredefinedNomination = {
    id: 8,
    get name() {
      return EstateTypeLang.guardianNomination;
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static ALTERNATE_GUARDIAN: PredefinedNomination = {
    id: 9,
    get name() {
      return Lang.t('nomination.alternate-guardian');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static PET_GUARDIAN: PredefinedNomination = {
    id: 10,
    get name() {
      return Lang.t('nomination.pet-guardian');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static ALTERNATE_PET_GUARDIAN: PredefinedNomination = {
    id: 11,
    get name() {
      return Lang.t('nomination.alternate-pet-guardian');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static POWER_OF_ATTORNEY_OF_PROPERTY: PredefinedNomination = {
    id: 12,
    get name() {
      return Lang.t('nomination.power-of-attorney-of-property');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static ALTERNATE_POWER_OF_ATTORNEY_OF_PROPERTY: PredefinedNomination = {
    id: 13,
    get name() {
      return Lang.t('nomination.alternate-power-of-attorney-of-property');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static POWER_OF_ATTORNEY_OF_PERSONAL_CARE: PredefinedNomination = {
    id: 14,
    get name() {
      return Lang.t('nomination.power-of-attorney-of-personal-care');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static ALTERNATE_POWER_OF_ATTORNEY_OF_PERSONAL_CARE: PredefinedNomination = {
    id: 15,
    get name() {
      return Lang.t('nomination.alternate-power-of-attorney-of-personal-care');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static MANDATARY_FOR_PROPERTY: PredefinedNomination = {
    id: 16,
    get name() {
      return Lang.t('nomination.mandatary-for-property');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static ALTERNATE_MANDATARY_FOR_PROPERTY: PredefinedNomination = {
    id: 17,
    get name() {
      return Lang.t('nomination.alternate-mandatary-for-property');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static MANDATARY_FOR_PERSONAL_CARE: PredefinedNomination = {
    id: 18,
    get name() {
      return Lang.t('nomination.mandatary-for-personal-care');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static ALTERNATE_MANDATARY_FOR_PERSONAL_CARE: PredefinedNomination = {
    id: 19,
    get name() {
      return Lang.t('nomination.alternate-mandatary-for-personal-care');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static VERIFIER_FOR_PROTECTION_OF_PROPERTY: PredefinedNomination = {
    id: 20,
    get name() {
      return Lang.t('nomination.verifier-for-protection-of-property');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static ALTERNATE_VERIFIER_FOR_PROTECTION_OF_PROPERTY: PredefinedNomination = {
    id: 21,
    get name() {
      return Lang.t('nomination.alternate-verifier-for-protection-of-property');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static INTERESTED_PARTY: PredefinedNomination = {
    id: 22,
    get name() {
      return Lang.t('nomination.interested-party');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static POWER_OF_ATTORNEY_OF_PROPERTY_HOMESTEAD: PredefinedNomination = {
    id: 23,
    get name(): string {
      return Lang.t('nomination.power-of-attorney-of-property-homestead');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static ALTERNATE_POWER_OF_ATTORNEY_OF_PROPERTY_HOMESTEAD: PredefinedNomination = {
    id: 24,
    get name(): string {
      return Lang.t('nomination.alternate-power-of-attorney-of-property-homestead');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };

  static POWER_OF_ATTORNEY_OF_PROPERTY_RECIPIENT: PredefinedNomination = {
    id: 25,
    get name(): string {
      return Lang.t('nomination.power-of-attorney-of-property-recipient');
    },
    type: null,
    clearVaultAccess: true,
    clearEstateAccess: true
  };
}
